import styled from '@emotion/styled'
import { SvgIcon, SvgIconProps } from '@mui/material'

const StyledPath = styled.path`
  stroke-width: 0.5px;
  stroke: ${(p) => p.theme.colors.white};
  fill: ${(p) => p.theme.colors.oceanBlue};
`
const WorkIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 38.808 48.829">
    <g transform="translate(-18.25 -10.072)">
      <StyledPath
        d="M21.808 58.161l.267.267h12.916l.267-.267c.135-.135 3.308-3.415 3.308-12.806 0-7.413-1.977-11.018-2.876-12.275l1.919-3.839h-3.6V26.2h-3.04v-7.992l1.628-3.256L30.617 11h-4.168l-1.976 3.952 1.627 3.256V26.2h-3.04v3.04h-3.6l1.919 3.839c-.9 1.256-2.876 4.862-2.876 12.275-.003 9.392 3.169 12.672 3.305 12.807zm5.769-45.337h1.913l1.064 2.128-1.413 2.825V26.2h-1.216v-8.423l-1.413-2.825zm-2.692 15.2h7.3v1.216h-7.3zm3.648 3.04h6.125l-.608 1.216H23.016l-.608-1.216zm-5.646 3.04h11.292c.641.883 2.563 4.123 2.563 11.249S34.829 55.71 34.181 56.6H22.886c-.648-.9-2.562-4.149-2.562-11.249 0-7.132 1.921-10.363 2.563-11.245z"
        transform="translate(0 -.228)"
      />
      <StyledPath d="M0 0H1.824V6.081H0z" transform="translate(23.06 42.087)" />
      <StyledPath
        d="M0 0H1.824V12.161H0z"
        transform="translate(27.621 39.047)"
      />
      <StyledPath
        d="M0 0H1.824V6.081H0z"
        transform="translate(32.181 42.087)"
      />
      <StyledPath
        d="M70.526 19.285c0-6.661-4.973-8.4-5.184-8.466l-1.2-.4v6.434h-4.257v-6.434l-1.2.4c-.211.07-5.184 1.8-5.184 8.466 0 4.218 3.237 6.066 6.081 6.707v16.989c-2.844.641-6.081 2.489-6.081 6.707 0 6.661 4.973 8.4 5.184 8.466l1.2.4V52.12h4.256v6.434l1.2-.4c.211-.07 5.184-1.8 5.184-8.466 0-4.218-3.237-6.066-6.081-6.707V25.992c2.845-.641 6.082-2.492 6.082-6.707zM68.7 49.688a7.093 7.093 0 0 1-2.736 6.066V50.3h-7.9v5.457a7.092 7.092 0 0 1-2.736-6.065c0-5.084 6.408-5.168 6.688-5.169s6.684.077 6.684 5.165zm-7.3-6.972V26.258c.212.013.416.02.608.02s.4-.007.608-.02v16.458c-.212-.013-.416-.02-.608-.02s-.391.004-.608.02zm.609-18.262c-.281 0-6.69-.084-6.69-5.169a7.093 7.093 0 0 1 2.736-6.066v5.458h7.9V13.22a7.092 7.092 0 0 1 2.745 6.065c0 5.085-6.407 5.168-6.686 5.169z"
        transform="translate(-13.718)"
      />
    </g>
  </SvgIcon>
)

export default WorkIcon
